import React from 'react';
import { TextProps } from '.';
import { A_TEXT, EM_TEXT, P_TEXT, Q_TEXT, SPAN_TEXT, STRONG_TEXT } from './texts';

type TextTypes = 'p' | 'span' | 'a' | 'em' | 'strong' | 'q';

export interface TextComponentProps extends TextProps {
    component?: TextTypes;
    children?: React.ReactNode;
}

export const Text: React.FC<TextComponentProps> = React.memo(
    ({ component, children, ...otherProps }) =>
        component === 'a' ? (
            <A_TEXT {...otherProps}>{children}</A_TEXT>
        ) : component === 'em' ? (
            <EM_TEXT {...otherProps}>{children}</EM_TEXT>
        ) : component === 'q' ? (
            <Q_TEXT {...otherProps}>{children}</Q_TEXT>
        ) : component === 'span' ? (
            <SPAN_TEXT {...otherProps}>{children}</SPAN_TEXT>
        ) : component === 'strong' ? (
            <STRONG_TEXT {...otherProps}>{children}</STRONG_TEXT>
        ) : (
            <P_TEXT {...otherProps}>{children}</P_TEXT>
        )
);
